import React from 'react';
import MaskedInput from 'spa/Components/MaskedInput';

import InputField from './InputField';

class MaskedField extends React.Component {
  render() {
    const {props} = this;

    return (
      <InputField {...props} type={MaskedInput} />
    );
  }
}

export default MaskedField;



// WEBPACK FOOTER //
// ./spa/Components/Form/MaskedField.jsx